import React from 'react';
import TagManager from 'react-gtm-module';
import { ThemeProvider } from '@mui/material/styles';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import CssBaseline from '@mui/material/CssBaseline';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { BrowserRouter } from 'react-router-dom';
import primaryTheme from '../themes/primaryTheme';
import { persistor, store } from '../redux/store';
import { Navigation } from '../routes/Navigation';
import { getEnv } from '../config';

const { googleReCaptcha, googleTagManager } = getEnv();

if (googleTagManager) {
  const tagManagerArgs = {
    gtmId: googleTagManager,
  };

  TagManager.initialize(tagManagerArgs);
}

const App = () => {
  return (
    <>
      <GoogleReCaptchaProvider
        reCaptchaKey={googleReCaptcha}
        language="es"
        scriptProps={{
          async: false, // optional, default to false,
          defer: false, // optional, default to false
          appendTo: 'head', // optional, default to "head", can be "head" or "body",
          nonce: undefined, // optional, default undefined
        }}
      >
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <ThemeProvider theme={primaryTheme}>
              <CssBaseline />
              <BrowserRouter>
                <Navigation />
              </BrowserRouter>
            </ThemeProvider>
          </PersistGate>
        </Provider>
      </GoogleReCaptchaProvider>
    </>
  );
};

export default App;
